import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import InternalForm from "@/components/transfers/InternalForm";
import ZelleForm from "@/components/transfers/ZelleForm";
import ExternalPanel from "@/components/transfers/ExternalPanel";

export default function Transfers() {
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState(null);
  const load = () => api.get("/dashboard").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  const tab = sp.get("tab") || "internal";

  return (
    <div data-testid="transfers-page">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-[var(--navy)] mb-2">Pay & Transfer</h1>
      <p className="text-slate-500 mb-8">Move money between your accounts, send with Zelle, or transfer to linked external banks.</p>
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
        <TabsList className="mb-6 bg-white border h-11">
          <TabsTrigger value="internal" data-testid="tab-internal">Between my accounts</TabsTrigger>
          <TabsTrigger value="zelle" data-testid="tab-zelle">Zelle</TabsTrigger>
          <TabsTrigger value="external" data-testid="tab-external">External accounts</TabsTrigger>
        </TabsList>
        {data && (
          <>
            <TabsContent value="internal"><InternalForm data={data} onDone={load} defaultCard={sp.get("card")} /></TabsContent>
            <TabsContent value="zelle"><ZelleForm accounts={data.accounts} onDone={load} /></TabsContent>
            <TabsContent value="external"><ExternalPanel accounts={data.accounts} onDone={load} /></TabsContent>
          </>
        )}
      </Tabs>
    </div>
  );
}
